import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=6f83b81c&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=6f83b81c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f83b81c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f83b81c')) {
      api.createRecord('6f83b81c', component.options)
    } else {
      api.reload('6f83b81c', component.options)
    }
    module.hot.accept("./SignUp.vue?vue&type=template&id=6f83b81c&scoped=true", function () {
      api.rerender('6f83b81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SignUp.vue"
export default component.exports